import theme from '../theme';

export const inlineDisplayBreak = theme.breakpoints.mobileBreak + 'em';
export const inlineDisplayMediumBreak = theme.breakpoints.mobileMediumBreak + 'em';
